export const SUCCESS_REVIEWS = 'SUCCESS_REVIEWS';